import actions from './actions';

const initialState = {
    proveedores: [],
    currentProveedor: null,
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_PROVEEDORES_SUCCESS:
            return {
                ...state,
                proveedores: action.payload
            }
        case actions.SET_CURRENT_PROVEEDOR:
            return {
                ...state,
                currentProveedor: action.payload
            }
        case actions.CLEAR_CURRENT_PROVEEDOR:
            return {
                ...state,
                currentProveedor: null
            }
        default:
            return state;
    }

}
